
import React from "react";
import "./SmallBusinessCleaningService.css";

const SmallBusinessCleaningService = () => {
  return (
    <div className="smallbusinesscleaning-cleaning-container">
      <h1>Professional Cleaning for Professional Spaces</h1>
      <p>Our Small Business Cleaning service keeps your office, studio, or retail space clean, safe, and welcoming for both staff and customers — with flexible scheduling and attention to detail.</p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Disinfecting desks, counters, and shared surfaces</li>
<li>Vacuuming and mopping floors</li>
<li>Restroom cleaning and restocking</li>
<li>Trash and recycling removal</li>
<li>Breakroom/kitchenette cleaning</li>

      </ul>
    </div>
  );
};

export default SmallBusinessCleaningService;
